import React from "react";
import {
  AlertNotification,
  H2,
  Popup,
  PopupHeader,
  XIcon,
} from "@commonsku/styles";
import { BASE_ZINDEX } from "../../../popup-factory";
import styled from "styled-components";

interface PushToShopifyErrorPopupProps {
  onClose: (popup: string) => void;
}

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const PushToShopifyErrorPopup = ({ onClose }: PushToShopifyErrorPopupProps) => {
  return (
    <>
      <Popup
        overlayZIndex={BASE_ZINDEX + 100}
        zIndex={BASE_ZINDEX + 200}
        style={{ width: 575, height: 184, borderRadius: 10 }}
        header={
          <PopupHeader
            style={{ padding: 0, alignItems: "center", marginBottom: 16 }}
          >
            <H2
              style={{
                fontSize: 24,
                lineHeight: "40px",
                margin: "0px",
              }}
              className="title"
            >
              Something Went Wrong
            </H2>
            <XIcon
              style={{ cursor: "pointer" }}
              size="large"
              onClick={() => onClose("")}
            />
          </PopupHeader>
        }
      >
        <StyledContainer>
          <AlertNotification
            alertType={"error"}
            style={{ height: 80, alignItems: "center" }}
          >
            Push to Shopify failed. Please try again. If the problem persists,
            please contact support.
          </AlertNotification>
        </StyledContainer>
      </Popup>
    </>
  );
};

export default PushToShopifyErrorPopup;
